(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["varena-header"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){const open=event.target.closest('[data-va-menu-open]');if(open){open.closest('.shopify-section').querySelector('.va-menu').showModal();}const close=event.target.closest('[data-va-menu-close]');if(close){close.closest('dialog').close();}const link=event.target.closest('.va-menu a');if(link){link.closest('dialog').close();}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["varena-home"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){const view=event.target.closest('[data-va-view]');if(view){const gallery=view.closest('.va-gallery');gallery.querySelectorAll('[data-va-frame]').forEach(function(frame){frame.hidden=frame.dataset.vaFrame!==view.dataset.vaView;});gallery.querySelectorAll('[data-va-view]').forEach(function(button){button.setAttribute('aria-pressed',String(button===view));});}const scroll=event.target.closest('[data-va-scroll]');if(scroll){const grid=scroll.closest('.va-collection').querySelector('.va-grid');grid.scrollBy({left:Number(scroll.dataset.vaScroll)*grid.clientWidth*.8,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});}const open=event.target.closest('[data-va-open]');if(open){const dialog=document.getElementById(open.dataset.vaOpen);if(dialog){dialog.showModal();}}const close=event.target.closest('[data-va-close]');if(close){close.closest('dialog').close();}if(event.target.matches('dialog.va-dialog')){const r=event.target.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom){event.target.close();}}});

  } catch(e) { console.error(e); }
})();
})();
